// components/admin-dashboard/charts/CounselorPerformanceChart.js
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";
import { BarChart3 } from "lucide-react";
import { ChartCard } from "./ChartCard";
import { CustomTooltip } from "./CustomTooltip";
import { COLORS } from '../constants';

export const CounselorPerformanceChart = ({ data, isLoading }) => (
  <ChartCard title="Counselor Performance" icon={BarChart3} isLoading={isLoading}>
    <div className="h-[300px]">
      <ResponsiveContainer>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            tickFormatter={(value) => value.split(" ")[0]}
          />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar
            dataKey="sessions"
            fill={COLORS.primary}
            name="Sessions"
            radius={[4, 4, 0, 0]}
          />
          {/* <Bar
            dataKey="completionRate"
            fill={COLORS.secondary}
            name="Completion Rate"
            radius={[4, 4, 0, 0]}
          /> */}
        </BarChart>
      </ResponsiveContainer>
    </div>
  </ChartCard>
);